import { useTranslation } from "react-i18next"

import Loading from "@/components/Loading/Loading"
import NoMessage from "@/components/noMessage/NoMessage"
import { useLatestFeedbackData } from "@/queries/queries"

import FeedbackCard from "./FeedbackCard"

export default function Feedback() {
  const latestFeedbackQuery = useLatestFeedbackData()
  const { t } = useTranslation()

  let content
  if (latestFeedbackQuery.isLoading) {
    content = <Loading />
  } else if (!latestFeedbackQuery.data?.length) {
    content = <NoMessage name={t("noMessages.feedbacks")} />
  } else {
    content = (
      <>
        {latestFeedbackQuery.data.map((ele) => {
          return <FeedbackCard ele={ele} key={ele?.id} />
        })}
      </>
    )
  }

  return (
    <div className="mt-2">
      <h5 className="section-title">{t("homePage.feedbacks.title")}</h5>
      <div className="row g-4">{content}</div>
    </div>
  )
}
